import { Checkbox } from "@nextui-org/react";
const myInvoicescolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "invoiceNumber",
    label: "Invoice No",
  },
  {
    key: "subscriptionName",
    label: "Item",
  },
  {
    key: "orderDate",
    label: "Order Date ",
  },
  {
    key: "amount",
    label: "Amount",
  },
  {
    key: "actions",
    label: "Action",
  },
];

export { myInvoicescolumn };
